import { Header } from './Header'
import { PriceSummary } from '@/components/builder/PriceSummary'
import { MobilePriceBar } from '@/components/builder/MobilePriceBar'

interface Props {
  children: React.ReactNode
  showSummary?: boolean
}

export function BuilderLayout({ children, showSummary = true }: Props) {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Header variant="builder" />
      <div className="flex-1 flex overflow-hidden">
        <main className={`flex-1 overflow-y-auto pb-24 md:pb-0 ${showSummary ? 'md:mr-[360px]' : ''}`}>
          <div className="max-w-3xl mx-auto px-4 py-8">
            {children}
          </div>
        </main>

        {showSummary && (
          <aside className="hidden md:flex flex-col w-[360px] fixed right-0 top-14 bottom-0 bg-white border-l border-slate-200 overflow-y-auto">
            <PriceSummary />
          </aside>
        )}
      </div>

      {showSummary && (
        <div className="md:hidden fixed bottom-0 left-0 right-0 z-40">
          <MobilePriceBar />
        </div>
      )}
    </div>
  )
}
